import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { urgencyLevels } from "@/data/platformData";
import { AlertTriangle, Clock, Calendar, Check } from "lucide-react";
import { cn } from "@/lib/utils";

const iconMap = {
  urgent: AlertTriangle,
  deferrable: Clock,
  scheduled: Calendar
};

export const BookingUrgencyStep = ({ booking, updateBooking }) => {
  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-xl font-semibold">Livello di urgenza</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Influenza la disponibilità degli slot proposti e l'instradamento alla struttura accreditata.
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-3">
        {urgencyLevels.map(u => {
          const Icon = iconMap[u.id] || Calendar;
          const selected = booking.urgency === u.id;
          const colorMap = {
            urgent: "border-rose-300 bg-rose-50 dark:bg-rose-950/30 text-rose-700",
            deferrable: "border-amber-300 bg-amber-50 dark:bg-amber-950/30 text-amber-700",
            scheduled: "border-sky-300 bg-sky-50 dark:bg-sky-950/30 text-sky-700"
          };
          return (
            <Card
              key={u.id}
              onClick={() => updateBooking({ urgency: u.id })}
              data-testid={`booking-urgency-${u.id}`}
              className={cn(
                "p-5 cursor-pointer transition-all border-2",
                selected ? `${colorMap[u.id]} shadow-lg scale-[1.02]` : "border-border hover:border-primary/40"
              )}
            >
              <div className="flex items-start justify-between mb-3">
                <Icon className={cn("h-7 w-7", selected ? "" : "text-muted-foreground")} />
                {selected && <Check className="h-5 w-5" />}
              </div>
              <p className="font-semibold text-lg">{u.label}</p>
              <p className={cn("text-sm mt-1", selected ? "" : "text-muted-foreground")}>{u.description}</p>
            </Card>
          );
        })}
      </div>

      <div className="pt-4 space-y-2">
        <Label htmlFor="booking-notes">Note per la prenotazione (opzionale)</Label>
        <Textarea
          id="booking-notes"
          data-testid="booking-notes-input"
          value={booking.notes || ""}
          onChange={e => updateBooking({ notes: e.target.value })}
          placeholder="Es. paziente in carrozzina, presenza caregiver..."
          rows={3}
        />
      </div>
    </div>
  );
};

export default BookingUrgencyStep;
